export default "__VITE_ASSET__X$uZZ2x4__"